export const chaseOffers = [
  'Full-service business banking. Convenient access to all your business banking services in one place — lending, checking, credit card, and payment solutions.',
  'Your choice of payment types. Choose from a full range of options for accepting payments and making deposits that include Zelle®, Online Bill Pay, wire transfers, and ACH payments.',
  'Earn up to $500 when you open a new account. For new Chase business checking customers with qualifying activities'
];

export const boAAndBluevineOffers = [
  {
    title: 'Bank of America Business Banking',
    features: ['Earn bonuses totaling $300 to $800 with qualifying activities.']
  },
  {
    title: 'Bluevine Business Checking Account',
    features: [
      '6 months free of Bluevine Plus and the ability to earn a $300 signup bonus with qualifying activities.'
    ]
  }
];

export const chaseAndBluevineOffers = [
  {
    title: 'Business Banking',
    features: [
      'Earn up to $500 when you open a new Chase Business Complete Checking® account. For new Chase business checking customers with qualifying activities.'
    ]
  },
  {
    title: 'Bluevine Business Checking Account',
    features: [
      '6 months free of Bluevine Plus and the ability to earn a $300 signup bonus with qualifying activities.'
    ]
  }
];
